<!--
 * @Author: zhangmh31513
 * @Date: 2021-09-28 12:10:22
 * @LastEditTime: 2021-11-08 11:26:15
 * @LastEditors: zhangmh31513
 * @Description:
 * @FilePath: \openplat-web\src\gtn\views\frontViews\developerConference\activity.vue
 * 有问题请第一时间来联系我
-->
<template>
  <div class="activity-container">
    <videoPlayer :nowIsLive="0" :videoSrc="videoSrc" />
  </div>
</template>

<script>
import videoPlayer from "./components/videoCom";
export default {
  name: "activity",
  components: { videoPlayer },

  data() {
    return {
      videoSrc:
        "https://pull-c1.videocc.net/recordf/8851283da91630242239065f123.m3u8?auth_key=1636686537-0-0-e4af5ba54bf2d776085ab297c8ce043d"
    };
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
.activity-container {
  margin: 100px auto;
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/frontViews/developerConference/activity.vue